import assetPath from '/app/packages/lebenslauf/components/src/assets/open-sans-hebrew-bold.ttf';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')